import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { Trans, useTranslation } from "react-i18next";
import { NOT_LOADED } from "../Infra/RemoteData";
import { HXButton } from "./HXButton";
import { HXPasswordTextField } from "./HXPasswordTextField";
import { PreLoginErrorIcon, PreLoginFormErrorMessage, PreLoginPasswordContent, PreLoginPasswordFields, PreLoginPasswordSuccessIcon, } from "./PreLoginBasePasswordView.styles";
import { PreLoginBaseView } from "./PreLoginPageBaseView";
import { ResetPasswordViewModel } from "./ResetPasswordViewModel";
import { spinner } from "./Spinner";
import { useViewModel } from "./useViewModel";
import { HXUserPasswordHints } from "./HXUserPasswordHints";
export const ResetPasswordView = observer((props) => {
    var _a;
    const model = useViewModel(ResetPasswordViewModel, props.container);
    const { t } = useTranslation();
    let title;
    let icon;
    if (model.newPasswordSaved) {
        title = "Password reset";
        icon = _jsx(PreLoginPasswordSuccessIcon, {});
    }
    else if (!model.user) {
        title = "Link expired";
        icon = _jsx(PreLoginErrorIcon, {});
    }
    else {
        title = "Enter a new password";
    }
    if (model.user === NOT_LOADED) {
        return spinner();
    }
    return (_jsxs(PreLoginBaseView, { title: title, icon: icon, container: props.container, showLanguageSwitcher: true, children: [_jsx(_Fragment, { children: model.newPasswordSaved ? (_jsx(_Fragment, { children: _jsx("div", { children: _jsx(Trans, { children: t("Your password has been successfully changed.") }) }) })) : (_jsx(_Fragment, { children: !model.user ? (_jsx("div", { children: _jsx(Trans, { children: t("Your password reset link is invalid or expired. Please request to reset your password again.") }) })) : (_jsxs(PreLoginPasswordContent, { children: [_jsxs(PreLoginPasswordFields, { children: [_jsx(HXPasswordTextField, { label: t("Enter new password"), value: model.input.password, onChange: (e) => model.updateInput({ password: e.target.value }) }), _jsx(HXPasswordTextField, { label: t("Confirm new password"), value: model.input.reEnteredPassword, onChange: (e) => model.updateInput({ reEnteredPassword: e.target.value }) }), _jsx(PreLoginFormErrorMessage, { children: model.error && _jsx("span", { children: model.error }) })] }), _jsx(HXUserPasswordHints, { minPasswordLength: (_a = model.organizationPasswordConfiguration) === null || _a === void 0 ? void 0 : _a.minPasswordLength })] })) })) }), _jsx(_Fragment, { children: model.newPasswordSaved ? (_jsx(HXButton, { type: "submit", onClick: (e) => {
                        e.preventDefault();
                        void model.navigateToLoginPage();
                    }, children: t("Go to log in") })) : (model.user && (_jsx(_Fragment, { children: _jsx(HXButton, { type: "submit", onClick: (e) => {
                            e.preventDefault();
                            void model.updatePassword();
                        }, children: _jsx(Trans, { children: t("Reset password") }) }) }))) })] }));
});
